export const CATEGORIES = [
  "Site Clearance", "Earthwork", "Filling", "GSB", "WMM", "Bituminous Work",
  "PCC", "RCC", "Steel Reinforcement", "Shuttering", "Masonry", "Plastering",
  "Drainage", "Road Furniture", "Miscellaneous",
];

const n = (v) => Number(v) || 0;

export function computeItem(item, defaultDeduction) {
  const ded = item.deduction === null || item.deduction === undefined || item.deduction === "" ? n(defaultDeduction) : n(item.deduction);
  const qty = n(item.quantity);
  const govt = n(item.govt_rate);
  const effective = govt * (1 - ded / 100);
  const revenue = qty * effective;
  const expenditure = qty * n(item.market_rate);
  const profit = revenue - expenditure;
  return {
    ded, effective, revenue, expenditure, profit,
    govtAmount: qty * govt,
    margin: revenue ? (profit / revenue) * 100 : 0,
  };
}

export function computeProject(project) {
  const items = project?.items || [];
  const rows = items.map((i) => computeItem(i, project.default_deduction));
  const sum = (k) => rows.reduce((s, r) => s + r[k], 0);
  const govtAmount = sum("govtAmount");
  const revenue = sum("revenue");
  const expenditure = sum("expenditure");
  const profit = revenue - expenditure;
  const gstRate = n(project?.gst_rate);
  const gst = (revenue * gstRate) / 100;
  const cats = {};
  items.forEach((it, idx) => {
    const key = it.category || "Miscellaneous";
    const c = (cats[key] = cats[key] || { category: key, count: 0, govtAmount: 0, revenue: 0, expenditure: 0, profit: 0 });
    c.count += 1;
    ["govtAmount", "revenue", "expenditure", "profit"].forEach((k) => (c[k] += rows[idx][k]));
  });
  const categories = Object.values(cats)
    .map((c) => ({ ...c, margin: c.revenue ? (c.profit / c.revenue) * 100 : 0 }))
    .sort((a, b) => b.govtAmount - a.govtAmount);
  return {
    rows, categories, govtAmount, revenue, expenditure, profit, gstRate, gst,
    cgst: gst / 2, sgst: gst / 2, revenueWithGst: revenue + gst,
    deductionAmount: govtAmount - revenue,
    margin: revenue ? (profit / revenue) * 100 : 0,
    itemCount: items.length,
    pricedCount: items.filter((i) => n(i.market_rate) > 0).length,
  };
}

export const newItem = () => ({
  item_id: Math.random().toString(16).slice(2, 14),
  item_no: "", description: "", category: "Miscellaneous", quantity: 0, unit: "",
  govt_rate: 0, deduction: null, market_rate: 0, remarks: "",
});
